import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchBadges } from './slices/badgesSlice'
import { fetchUserProfile, subscribeToProfileChanges } from './slices/userPublicSlice'
import { fetchJackpots } from './slices/jackpotSlice'
import { fetchLevels } from './slices/levelSlice'
import { fetchMissions, subscribeToMissionUpdates } from './slices/missionsSlice'
import { fetchTournamentsList, subscribeToTournamentsUpdates } from './slices/tournamentListSlice'
import { fetchMinigamesList, subscribeToMinigamesUpdates } from './slices/miniGamesSlice'
import { fetchInboxMessages, subscribeToMessagesUpdates } from './slices/inboxSlice'
import { fetchStoreItems } from './slices/storeSlice'

export const reInitDataForLanguage = createAsyncThunk('init/reInitDataForLanguage', async (languageCode: string, { dispatch }) => {
	dispatch(fetchBadges())
	dispatch(fetchUserProfile())
	dispatch(subscribeToProfileChanges())
	dispatch(fetchJackpots())
	dispatch(fetchLevels())
	dispatch(fetchMissions())
	dispatch(subscribeToMissionUpdates())
	dispatch(fetchTournamentsList())
	dispatch(subscribeToTournamentsUpdates())
	dispatch(fetchMinigamesList())
	dispatch(subscribeToMinigamesUpdates())
	dispatch(fetchInboxMessages({ from: 0, to: 19 }))
	dispatch(subscribeToMessagesUpdates())
    dispatch(fetchStoreItems())
})
